module.exports = __webpack_public_path__ + "img/1_2023-04-20--TERRY-FOX-Duo-Reg-men.6fd5cc72.jpg";